import { Button } from "@/design-system/components/Button/Button";
import { colors } from "@material-ui/core";
import React from "react";
import { toast } from "@/design-system/components/Toast/Toast";

import { makeRequest } from "../../../util";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { GoogleAdsIcon } from "../../../components/icons/themes/logos";

const CustomerIDModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["customerId"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const CustomerIDRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "customerId" in settings;

  return (
    <DestinationConfigRow
      name="Customer ID"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthModal = () => {
  return null;
};

const OAuthRow = ({ existingConfig }) => {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  const onOpenConfigModal = () => {
    makeRequest("get_oauth_url", {
      integration_name: "google-ads-remarketing-lists",
      destination_id: existingConfig?.id,
    })
      .then((response) => {
        window.location = response.data;
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Something went wrong. Unable to setup Google Ads Remarketing Lists.",
        );
      });
  };

  const loginButton = (
    <Button
      variant="outline"
      onClick={onOpenConfigModal}
      className="text-grey font-semi-bold inline-block w-auto cursor-pointer rounded px-2 py-1"
    >
      <GoogleAdsIcon
        className="position mr-2 fill-white"
        height="2em"
        style={{ top: -2 }}
      />
      {oauthConfigured ? "Reconnect" : "Login With Google"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access Permission"
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={onOpenConfigModal}
    />
  );
};

const CUSTOMER_ID = "CUSTOMER_ID";
const OAUTH = "OAUTH";

const Rows = {
  [CUSTOMER_ID]: CustomerIDRow,
  [OAUTH]: OAuthRow,
};

const Modals = {
  [CUSTOMER_ID]: CustomerIDModal,
  [OAUTH]: OAuthModal,
};

const RowOrder = [CUSTOMER_ID, OAUTH];

export default {
  Rows,
  RowOrder,
  Modals,
};
